import React from 'react';
import InterviewPreviewContainer from '../components/interview-preview/InterviewPreviewContainer';
interface InterviewPreviewPageProps {
  userDetails: {
    id: string;
    name: string;
    profilePicture?: string;
  };
}
const InterviewPreviewPage: React.FC<InterviewPreviewPageProps> = ({ userDetails }) => {
  return <InterviewPreviewContainer userDetails={userDetails} />;
};

export default InterviewPreviewPage; 